/**
 * Web shim for React Native IAP
 * Since react-native-iap doesn't support web, we provide a mock implementation
 */

import { 
  PaymentProvider,
  SubscriptionPlan,
  PurchaseResult,
  PaymentError,
  SubscriptionStatus,
  PurchaseHistory,
  RestorePurchasesResult
} from './types';

class ReactNativePaymentServiceWeb implements PaymentProvider {
  async initialize(): Promise<void> {
    console.log('[ReactNativePaymentService] Web version - IAP not supported on web platform');
    return Promise.resolve();
  }

  async purchaseSubscription(plan: SubscriptionPlan): Promise<PurchaseResult> {
    console.log('[ReactNativePaymentService] Web purchase attempt for plan:', plan.id);
    throw new Error('In-app purchases are not available on web. Please use the mobile app.');
  }
  
  async purchaseEventPass(sku: string): Promise<PurchaseResult> {
    console.log('[ReactNativePaymentService] Web event pass purchase attempt for SKU:', sku);
    throw new Error('In-app purchases are not available on web. Please use the mobile app.');
  }

  async restorePurchases(): Promise<RestorePurchasesResult> {
    console.log('[ReactNativePaymentService] Web restore attempt');
    return {
      success: false,
      restoredPurchases: [],
      error: 'Restore purchases is not available on web'
    };
  }

  async getSubscriptionStatus(): Promise<SubscriptionStatus | null> {
    return null;
  }

  async getPurchaseHistory(): Promise<PurchaseHistory[]> {
    return [];
  }

  async cancelSubscription(subscriptionId: string): Promise<void> {
    console.log('[ReactNativePaymentService] Web cancel attempt for:', subscriptionId);
    throw new Error('Subscription management is not available on web');
  }

  async validateReceipt(receipt: string): Promise<boolean> {
    return false;
  }

  isAvailable(): boolean {
    return false;
  }

  cleanup(): void {
    // No cleanup needed for web
  }
}

export default ReactNativePaymentServiceWeb;
